// import DefaultLayout from './container/DefaultLayout/DefaultLayout';
import MainView from "./view/main/main-view";
import ServicesView from "./view/services/services-view";
import ServiceDetailView from "./view/service-detail/service-detail-view";
import DemoView from "./view/demo/demo-view";
import Information from "./view/information/information";
import Page404 from "./components/page404/page404";

let route = [
  // {path: '/', exact: true, name: 'Home', component: DefaultLayout},
  { path: "/", exact: true, name: "Intro", component: MainView },
  {
    path: "/services",
    exact: true,
    name: "Services-view",
    component: ServicesView
  },
  {
    path: "/service-detail",
    exact: true,
    name: "Services-view",
    component: ServicesView
  },
  {
    path: "/service-detail/:id",
    exact: true,
    name: "service-detail-view",
    component: ServiceDetailView
  },
  {
    path: "/service-detail/:id/demo",
    exact: true,
    name: "demo-view",
    component: DemoView
  },
  {
    path: "/service-detail/:id/fleets",
    exact: true,
    name: "demo-view",
    component: DemoView
  },
  {
    path: "/service-detail/:id/intro",
    exact: true,
    name: "demo-view",
    component: DemoView
  },
  {
    path: "/help/api-key",
    exact: true,
    name: "help/api-key",
    component: Information
  },
  {
    path: "*",
    exact: true,
    name: "Page404",
    component: Page404
  }
];

export default route;
